module.exports = __webpack_public_path__ + "img/mobile-app-qr-code.7c6a22e7.png";